import { MODAL_PROJECT_INFORMATION } from '@components/App/Modal/constants'
import { openLeaveFeedbackModal } from '@components/App/Modal/LeaveFeedback'
import Welcome from '@components/App/Welcome'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { createSwitch } from '@/utils'

export const useProjectInfo = () => {
  const dispatch = useDispatch()

  const switcher = createSwitch()
    .case(['about'], Welcome)
    .case(['shortcuts'], () => dispatch(openModal(MODAL_PROJECT_INFORMATION)))
    .case(['feedback'], () => dispatch(openLeaveFeedbackModal('general')))

  const onClick = (keys: string[]) => switcher.run(keys)

  return {
    onClick,
  }
}
